<template>
  <div id="autumn">
    <div class="top">
    </div>
      <div class="bottom">
        <div class="maples">
          <img :src="'./img/maples.png'">
          <img :src="'./img/maples.png'">
        </div>
      </div>
  </div>
</template>
<script>
export default {
}
</script>
